<template>
    <!--场地类型-->
    <el-select :value="value" :size="size" @visible-change="visiblechange" :placeholder="placeholder" @change="change" >
        <el-option
                v-for="item in list"
                :key="item.houseTypeId"
                :label="item.houseTypeName"
                :value="item.houseTypeId">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "house-type",
        props: {
            size: String,
            placeholder: String,
            value:String,
        },
        model: {
            prop: 'value',
            event: 'input'
        },
        data() {
            return {
                list: [],
            }
        },
        mounted(){
          this.getData();
        },
        methods: {
            getData(){
                this.$axios.get("/house/houseTypeListByStoreId/"+this.$root.getStorage('storeId')).then(res => {
                    // console.log('场地类型',res)
                    this.list = res.data.list;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            visiblechange(isshow) {
                if (isshow) {
                    this.getData();
                }
            },
            change(value) {
                this.$emit('input', value)
            }
        }
    }
</script>

<style scoped>

</style>